import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { deleteItem } from "../../api/generics";
import BettingUser from "../../models/betting-user";

interface BettingUserDeleteModalProps {
  show: boolean;
  bettingUser?: BettingUser;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const BettingUserDeleteModal: React.FC<BettingUserDeleteModalProps> = ({
  show,
  bettingUser,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = bettingUser
    ? `Está seguro de que quiere eliminar el Jugador ${bettingUser.name}`
    : "";

  const onDeleteClick = async () => {
    if (bettingUser !== undefined) {
      setSubmitting(true);
      const bettinguserStatus = await deleteItem<BettingUser>(`/betting_users/${bettingUser.id}/`, bettingUser);

      if (bettinguserStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (bettinguserStatus.detail !== undefined) {
          message = bettinguserStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default BettingUserDeleteModal;
